import ClearingAPI from '@shared/api';

export const { getRIADashboard } = ClearingAPI.settings.users;
